<template>
    <div>
        <v-row no-gutters align="center" class="font-size-16 font-size-md-24 font-weight-regular font-pretendard">
            <v-col cols="12" md="auto" data-aos="fade-right" data-aos-delay="100">
                <div class="px-12px pt-10px pl-md-0 pr-md-20px py-md-24px py-lg-40px w-md-160px">
                    <div class="font-weight-extrabold grey--text text--darken-4">
                        <slot name="title" />
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="" data-aos="fade-left" data-aos-delay="100">
                <div class="px-12px pt-4px pb-10px px-md-20px py-md-24px py-lg-40px">
                    <div class="font-size-18 font-size-md-24">
                        <slot name="text" />
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-divider />
    </div>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
